import React, {useState} from 'react'
import _ from 'lodash'
import { Snackbar, ButtonGroup,FormHelperText,Avatar,Typography,
        Button, Box, Checkbox, InputLabel, TextField, Select, MenuItem,
         FormControl, FormControlLabel, Fade  } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Alert} from '@material-ui/lab';
import { useForm } from "react-hook-form";
import * as firebase from 'firebase';
import dayjs from 'dayjs'
import CheckIcon from '@material-ui/icons/Check';
import { green } from '@material-ui/core/colors';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import ReactPixel from 'react-facebook-pixel';
import VotingScreen from './VotingScreen';
import AdditionalForm from './AdditionalForm'
import {tankstellen} from './TankstelleListe'




// ReactGA.initialize('UA-176148941-1',{
//   debug: true,
//   gaOptions: {
//     siteSpeedSampleRate: 100,
//     allowLinker: true
//   }
// })

// ReactGA.ga('require', 'linker');
// ReactGA.ga('linker:autoLink', ['meintankpreis.web.app', 'meintankpreis.de']);



const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: true, // enable logs
};

ReactPixel.init('395616084762998', options);

const useStyles = makeStyles((theme)=>({
    input:{
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      width: '100%'
    },
    successContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center'
    },
    icon: {
      color: theme.palette.getContrastText(green[700]),
      backgroundColor: green[600],
      height: '80px',
      width: '80px',
      marginBottom: theme.spacing(4)
    },
    button:{
      color:'white',
      fontFamily: 'ShameimaruSans',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: '100%'
  },
  buttonSecondary:{
    fontFamily: 'ShameimaruSans',
    
    marginBottom: theme.spacing(2),
    width: '100%'
},
    progress:{
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
      },
    buttonGroup:{
      marginTop: theme.spacing(2),
      
    }, 
    toggleButton:{
      width:'150px'
    },
    viewButtonLabel:{
      textTransform: 'none'
    }, 
    title:{
      paddingTop:theme.spacing(2),
      paddingBottom:theme.spacing(2),
    },
    box:{
      display:'flex',
      justifyContent:'center'
  },
  zuruck:{
    color: theme.palette.text.secondary,
   
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  align:{
    display: 'flex',
    flexDirection: 'column',
    alignContent:'center',
    alignItems:'center'
  }, 
  

  }));
  
export default function CustomerForm() {
    const classes = useStyles()
    const theme = useTheme()
    const [station, setStation] = React.useState('');
    const [fuel, setFuel] = React.useState('');
    const [price, setPrice] = React.useState('')
    const [stations, setStations] = React.useState()
    const [state, setState] = React.useState()
    const [page, setPage] = React.useState(1)
    const [coupon, setCoupon] = React.useState()
    const [checked, setChecked] = React.useState(false)
    const [prices, setPrices] = React.useState()
    const [loading, setLoading] = React.useState(false)
    const [progress, setProgress] = React.useState(0)
    const [noStation, setnoStation] = React.useState(false)
    const { register, handleSubmit , errors, setValue } = useForm();
    let db = firebase.firestore()
    const functions = firebase.functions()
    const sendCoupon = functions.httpsCallable('sendCouponEmail')
    const [error, setError] = React.useState(false)
    const analytics = firebase.analytics();
    const [hasAnswered, setHasAnswered] = React.useState(false)
    const [favorite, setFavorite] = React.useState()
    const [error2, setError2] = React.useState()
    const [answer, setAnswer] = useState()
    const parseParams = (querystring) => {
      const params = new URLSearchParams(querystring);
      const obj = {};
      for (const key of params.keys()) {
          if (params.getAll(key).length > 1) {
              obj[key] = params.getAll(key);
          } else {
              obj[key] = params.get(key);
          }
      }
  
      return obj;
  };
  const urlParams = parseParams(window.location.search)
    let tankstellenIds = tankstellen.map((tank)=> tank.id)
  const handleBack = () =>{
    setFuel()
    setPrice()
    setProgress(0)
    setPage(1)
  }





    const submitAnswer=()=>{
        db.collection('answers').add({
          type:'open',
          answer: favorite,
        }).then(()=>{
          setHasAnswered(true)
          setStation()
          setnoStation(false)
        })
    
    }

    const names = tankstellen.map((tank)=>`${tank.brand} - ${tank.street}, ${tank.post_code} ${tank.place}`)
    console.log(names)
    // b3060ae1-10ad-4229-b2db-096372950f51,8a7a3916-0deb-46ba-bef9-4531c0cb1c7c,73f34ee9-64ab-4009-a092-575ce13ce326,be5c6214-ea9b-4fde-8355-42b80dbcb9df
    
const handleAnswer = (event, value)=> {
  // db.collection('votes').add({
  //   type:'total',
  //   value:answer,
  //   time: new Date()
  // }).then(()=>{
    
// })
    setError()
    console.log( event.target.value)
    setAnswer(event.target.value)
}
   


    React.useEffect(() => {
      if(state){
        setPrices(state.prices[station.id])
      }
    }, [state])

    const handleStationChange = (event, newValue) => {
      
      if(newValue.id=='none'){
       setPage(5)
       setStation(newValue.id)
       
      //  ReactGA.event({category:'popup',action:'viewedStations'})
      }else{
        setnoStation(false)
        setStation(newValue)
        fetch(`https://creativecommons.tankerkoenig.de/json/prices.php?ids=${newValue.id}&apikey=b2286900-6abe-8fc5-0f11-16ff21eb0a9d`)
        .then(res => res.json())
        .then((data) => {
          analytics.logEvent('selected_station',{ station_adress: newValue.street })
          // ReactGA.event({category:'popup',action:'selectedStation', label:stationNames[event.target.value]})
          setValue('station', newValue.id )
          setState(data)
          setFuel()
          setPrice()
          
        })
        .catch(console.log)
      }}

      
    const handleFuelChange = (event) => {
        analytics.logEvent('set_fuel', {fuel_type: event.target.value})
        // ReactGA.event({category:'popup',action:'setFuel', label: event.target.value})
        setError()
        setFuel(event.target.value);
        setValue('fuel', event.target.value)
        setPrice()
        // ReactGA.event({category:'popup',action:'setFuel', label: event.target.value})
        
    };

    const onSubmit=  (data) =>{
      const collectTime = new Date()
      const expiryTime = dayjs(collectTime).add(1, 'd')
      const tank = _.find(tankstellen, (tank)=> tank.id===station.id)
      
      if (fuel==undefined){
        setError('Bitte wählen Sie die Kraftstoffart.')
      }
      if(page==1&&fuel!=undefined){
        analytics.logEvent('clicked_jetzt_sichern',{fuel_type:fuel, station_adress: station.street , price: price})
        // ReactGA.event({category:'popup',action:'jetzt-sichern'})
        setProgress(50)
        setPage(2)}
      if(page==2){
        if(!answer){
          setError('Dieses Feld ist erforderlich.')
        }else{
          const couponCode= Math.floor(100000 + Math.random() * 900000)
          setCoupon(couponCode)
          setProgress(100)
          db.collection('coupons').add({
            code: couponCode,
            email: data.email,
            stationAdress: `${tank.brand} - ${tank.street}, ${tank.post_code} ${tank.place}`,
            stationCode: data.station,
            fuel: data.fuel,
            fuelType: data.fuel!=='diesel'?'Super '+_.capitalize(data.fuel):_.capitalize(data.fuel),
            fuelPrice: `${_.round(prices[fuel],2).toFixed(2)} €`,
            price: prices[fuel].toFixed(2), 
            claimedTime: collectTime,
            collected: false,
            expiryTime: dayjs(expiryTime).format('DD.MM.YYYY HH:mm'),
            howOften: answer,
            ...urlParams
          }).then(()=>{
              ReactPixel.track('CompleteRegistration',{value:1, currency:'EUR'})
              // ReactGA.event({category:'popup',action:'registered'})
              analytics.logEvent('reserved_coupon',{fuel_type:fuel, station_adress:station.street , price: price})
              setProgress(100)
              setLoading(false)
              setPage(3)}
            ).catch((error)=>{
            setLoading(false)
            setError2('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal später.')
            console.log(error.code, error, error.message)}
            )
        }
          
        
       
      }  
    }


  React.useEffect(() => {
    register({name: 'station'}, {required: true});
    register({name: 'fuel'}, {required: true});
  }, [register])


console.log(station)

    return (
        <div>
        <form onSubmit={handleSubmit(onSubmit)}>
        {page==3||page==4?null:
        <React.Fragment>
        <Typography style={{fontFamily: 'ShameimaruSansAlternatives', paddingBottom: theme.spacing(2)}} variant='h5' color='textPrimary'>
        {page==1?'Wähle die Tankstelle und den Kraftstoff:':page==4?'Wir freuen uns über dein Feedback':page==5?'Wo würdest du gerne tanken?':'Gebe deine E-Mailadresse ein:'}
        </Typography>
        
        <LinearProgress variant="determinate" value={progress} color='secondary'/>
        </React.Fragment>}
        {page==1?
        <React.Fragment>
        <FormControl className={classes.input} variant='outlined'> 
            {/* <InputLabel color='secondary' htmlFor="station">Tankstelle auswählen</InputLabel> */}
            <Autocomplete
                  id="tankstellen"
                  noOptionsText='Leider kein Treffer, versuche bitte eine andere PLZ'
                  // helperText='Tipp: Gib nur die ersten 2-3 PLZ-Ziffern ein, so findest du alle Tankstellen in der Nähe.'
                  required
                  disableClearable
                  options={tankstellen}
                  getOptionLabel={(tank)=>`${tank.brand} - ${tank.street}, ${tank.post_code} ${tank.place}`}
                  onChange={handleStationChange}
                  renderInput={(params) => <TextField {...params} label="PLZ eingeben" variant="outlined" color='secondary' />}
                />
                <FormHelperText >Tipp: Gib nur die ersten 2-3 PLZ-Ziffern ein, so findest du alle Tankstellen in der Nähe </FormHelperText>
                
        </FormControl>
        <FormControl className={classes.input} variant='outlined'> 
            <InputLabel color='secondary' id="fuelid">Kraftstoffart</InputLabel>
            <Select 
                disabled={!state||prices?.status!=='open'}
                labelId="fuelid"
                name='fuel'
                required
                fullWidth
                value={fuel}
                onChange={handleFuelChange}
                label="Kraftstoffart"
                color='secondary'
                >
                {_.map(prices, (value, key) => (
                    key!=='status'?
                    <MenuItem value={key} >{key!=='diesel'?'Super '+_.capitalize(key):_.capitalize(key)} Preis: {_.round(value,2).toFixed(2)}€</MenuItem>:null
                ))}
                </Select>
                <FormHelperText >Hinweis: Bei den aufgeführten Kraftstoff-Preisen handelt es sich um auf volle Cent-Beträge aufgerundete Preise</FormHelperText>
                {error||!prices?.status==='open'||!prices?.status===undefined?<FormHelperText error>{error||'Diese Tankstelle ist derzeit nicht geöffnet. Bitte wählen sie eine andere Tankstelle.'}</FormHelperText>:null}
                </FormControl>
        <Typography color='textPrimary' align='center'>
        {fuel&&!noStation?
        `Du wirst  ${fuel!=='diesel'?'Super '+_.capitalize(fuel):_.capitalize(fuel)} zum Preis von ${_.round(prices?prices[fuel]:null,2).toFixed(2)}€ an der Tankstelle ${station.brand} - ${station.street}, ${station.post_code} ${station.place} reservieren.`:null}
        </Typography>
            {noStation?
            <Button  className={classes.button} fullWidth onClick={()=>submitAnswer()} style={{color: 'white'}} color='secondary' variant='contained'>
                Senden</Button>:
            <Box>
            <Button className={classes.button} fullWidth type='submit'  style={{color: 'white'}} color='secondary' variant='contained'>
            {loading?<CircularProgress />:'Jetzt Tankpreis Sichern'}</Button>
            
            <Button  className={classes.buttonSecondary} fullWidth onClick={()=>{
              setPage(4)
              analytics.logEvent('nicht_fundig_geworden_click')
            }} color='secondary' variant='contained' fullWidth color='secondary' variant='outlined'>
            Du möchtest gerade nicht reservieren?<br/> Gib uns dein Feedback.
            </Button>
            <Typography variant='caption' color='textSecondary'>
            Keine Kreditkarten- oder Zahlungsinformationen notwendig. Die Reservierung ist 24 Stunden gültig und per Rabatt-Code einlösbar.
            </Typography>
            
            </Box>}
            {/* <Box style={{display:'flex', justifyContent:'center'}}>
            {noStation?null:
            <Typography align='center' variant='caption' color='textSecondary'>Keine Kreditkarten oder Zahlungsinformationen notwendig</Typography>}
            </Box> */}
            
           
        </React.Fragment>:
        page==2?
        <React.Fragment>
          <TextField 
            InputLabelProps={{
            style: { color: theme.palette.secondary },
              }}
            className={classes.input}
            inputRef={register({required:true})}
            name='email'
            variant='outlined' 
            label='Email'
            type='email'
            color='secondary'
            required
            />
        
        {/* <Divider style={{marginBottom: theme.spacing(2)}}/> */}
        <FormControl className={classes.input} variant='outlined'> 
            <InputLabel color='secondary' id="answerSelect">Wie oft tankst du bei TOTAL?</InputLabel>
     
        <Select 
                labelId="answerSelect"
                name='answerSelect2'
                variant='outlined'
                required
                fullWidth
                value={answer}
                onChange={handleAnswer}
                label="Wie oft tankst du bei TOTAL?"
                color='secondary'
                >
                <MenuItem value='nie' >Sonst nie </MenuItem>
                <MenuItem value='gelegentlich' >Gelegentlich </MenuItem>
                <MenuItem value='haufig' >Häufig </MenuItem>
                
        </Select>

   
        {error&&<FormHelperText error>{error}</FormHelperText>}
        </FormControl>
        {/* {answer?
          <Box className={classes.successContainer}>
                <Alert variant='filled' severity='success'  align='center' >
                Vielen Dank für dein Feedback.
                </Alert>
          </Box>
        : */}
        {/* <Box className={classes.align}>
        <Typography  style={{fontFamily: 'ShameimaruSansAlternatives'}} align='center' variant='h6' color='textSecondary'>
        Wie oft tankst du bei TOTAL?
        </Typography>
        
        <ToggleButtonGroup value={answer}  exclusive   className={classes.buttonGroup} size='medium' orientation='horizontal'    >
              <ToggleButton value='nie' classes={{ label: classes.viewButtonLabel, root:{color:'green'} }} className={classes.toggleButton} >Sonst nie</ToggleButton>
              <ToggleButton value='gelegentlich'  classes={{ label: classes.viewButtonLabel }} className={classes.toggleButton} >Gelegentlich</ToggleButton>
              <ToggleButton value='haufig'  classes={{ label: classes.viewButtonLabel }} className={classes.toggleButton} >Häufig</ToggleButton>
        </ToggleButtonGroup>
        </Box> */}
        {/* } */}
        {/* <Divider style={{marginBottom: theme.spacing(2),marginTop: theme.spacing(2)}}/> */}
        <FormControlLabel
          inputRef={register({required:true})}
          name='terms'
            control={<Checkbox onError={!checked} checked={checked} inputRef={register({required:true})} onChange={()=>setChecked(!checked)} />}
            label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
             Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
          />
          {errors?.terms?
          <Box style={{paddingLeft:theme.spacing(4)}}>
        <Typography  variant='caption' color='error' align='center'  >
        Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
        </Typography>
        </Box>:null
        }
        
        <Button className={classes.button} fullWidth type='submit' style={{color: 'white'}} color='secondary' variant='contained' >Senden</Button>
        <Typography  variant='caption' color={'textSecondary'} >Wir schicken dir deinen Rabatt-Code per E-Mail zu. Einfach bei der ausgewählten Tankstelle zeigen und günstiger tanken.</Typography>
        <Box className={classes.box}>
            <Button onClick={()=>handleBack()} variant='text' className={classes.zuruck}>Zurück</Button>
        </Box>
        </React.Fragment>:
        page==4?
        <VotingScreen changePage={setPage} setStation={setStation}/>:
        page==5?
        <AdditionalForm changePage={setPage} setStation={setStation} top={true}/>:
        <Box className={classes.successContainer}>
        <Avatar className={classes.icon}><CheckIcon fontSize='large'/></Avatar>
        <Typography color='textPrimary'  align='center' variant='h5'>
        Erfolgreich reserviert!<br/>Innerhalb der nächsten 15 Minuten findest du deinen Rabatt-Code in deinem Posteingang.
        <br/>Falls du nicht fündig wirst, schau bitte noch einmal im Spam-Ordner nach.
        </Typography>
        <Box className={classes.box}>
        <Button onClick={()=>handleBack()} variant='text' className={classes.zuruck}>Zurück</Button>
        </Box>
        </Box>}
        </form>
        {error2?
            <Snackbar open={error2?true:false}  onClose={()=>setError()}>
            <Alert onClose={()=>setError()} severity="error" variant='filled'>
                {error}
            </Alert>
            </Snackbar>:null}
        </div>
    )
}
